/**
 * Core spacing library
 *
 * https://www.figma.com/file/zYke5qihweC8yQSpXpcRO2/%F0%9F%93%9000-OM-CORE-Library?node-id=1133%3A4447
 */

// ============================================================================
// README
// ----------------------------------------------------------------------------
// The following objects are taken directly from the CORE figma diagram.
// No additions or changes should be made here, except to align with the CORE
// diagram.
// Changes to the CORE diagram should go through the process defined in RFC009.
// ============================================================================

// Note, this will have to change soon in line with our rem overhaul

const SPACING = {
  /** 0.25rem 4px */
  XXXS: '0.25rem',
  /** 0.5rem 8px */
  XXS: '0.5rem',
  /** 0.75rem 12px */
  XS: '0.75rem',
  /** 1rem 16px */
  S: '1rem',
  /** 1.25rem 20px */
  M: '1.25rem',
  /** 1.5rem 24px */
  L: '1.5rem',
  /** 2rem 32px */
  XL: '2rem',
  /** 2.5rem 40px */
  XXL: '2.5rem',
  /** 3rem 48px */
  XXXL: '3rem',
  /** 5rem 80px */
  XXXXL: '5rem',
};

export type SpacingKeys = keyof typeof SPACING;

export const SPACING_KEYS = Object.keys(SPACING);

export default SPACING;
